import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './buefy.js'
import './vee-validate.js'

import { initialize } from '@/firebase.js'

Vue.config.productionTip = false

initialize().then(() => {
  document.getElementById('loading').style.display = 'none'
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
